export enum TabSize {
  Little = 'little',
  Big = 'big',
}

export enum TabThemes {
  Primary = 'primary',
  Map = 'mapTab',
  Old = 'old',
  Filter = 'filter',
}

export interface Tab {
  title: string;
  index?: number;
  quantity?: number;
}

export interface TabProps extends Tab {
  className?: string;
  active: boolean;
  themes?: TabThemes;
  handler?: (index: number) => void;
}

export interface TabsTypeProps {
  className?: string;
  tabs: Tab[];
  countTab?: number;
  active: number;
  size?: TabSize;
  themes?: TabThemes;
  handlerBackValue?: (index: number) => void;
}
